import PropTypes from 'prop-types';
import React from 'react';
import ShapedButton from './ShapedButton';
import SvgIcon from './SvgIcon';

const CheckmarkTextButton = (props) => {
    const selectedClass = (isSelected) => `${(isSelected ? 'selected' : '')}`;
    return (
        <ShapedButton
            styles={`fluency-answer ${selectedClass(props.isSelected)}`}
            onClick={() => {
                props.onClick(props.index);
            }}>
            <p>{props.text}</p>
            <SvgIcon ariaLabelledBy="Popup checkmark" ariaDescribedBy="Checkmark in popup selection button" class="svg-check lantern-svg" id="check" />
        </ShapedButton>
    );
};

CheckmarkTextButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    index: PropTypes.number,
};

CheckmarkTextButton.defaultProps = {
    isSelected: false,
    index: undefined,
};

export default CheckmarkTextButton;
